import type { LocationIdentifier } from "~/types/api";

export const locationIdsMatch = (candidate: string | number, expected: LocationIdentifier): boolean =>
  String(candidate) === String(expected);
